export type Direction = 'ltr' | 'rtl'
const rtlLanguages = ['ar', 'he']

export const getDirection = (language?: string): Direction => {
  if (language && rtlLanguages.includes(language)) return 'rtl'
  return 'ltr'
}
